import './tripDetails.css';
import DetailsImageDisplay from '../../components/detailsImageDisplay/DetailsImageDisplay';
import TripBookingTab from './tripBookingTab/TripBookingTab';
import { useEffect, useRef, useState } from 'react';
import ReactLoading from 'react-loading';
import moment from 'moment';
import fetchTripData from './tripDetailsFun/fetchTripData';
import ReviewStars from '../../components/reviewStars/ReviewStars';
import { ReactComponent as Share } from '../../../assets/icons/trvto_share.svg';
import { share } from './tripDetailsFun/tripDetailsShare';
import EmptyPage from '../../../components/empty-page/emptyPage';
import { getFormattedDate } from '../../../utils/formatDate';
import { useNavigate } from 'react-router-dom';
import TripCard from '../../components/tripCard/TripCard';
// import { ReactComponent as LeftArrow } from '../../assets/icons/trvto_left_arrow_icon.svg';
// import { ReactComponent as RightArraow } from '../../assets/icons/trvto_right_arrow_icon.svg';
// import DetailsTabs from '../../components/detailsTabs/DetailsTabs';
// import { ReactComponent as LoveBlack } from '../../../assets/icons/trvto_wishlist.svg';
// import { ReactComponent as LoveRed } from '../../../assets/icons/trvto_favorite.svg';
import { getInterestedTripsOrg } from '../../api/infoOrgApi';
import { clearBookingStorage } from '../../../utils/clearStorage';
import DetailsTabs from '../../components/detailsTabs/DetailsTabs';

export default function TripDetails() {
    const isMobile = window.innerWidth < 768;
    const [packData, setPackData] = useState({});
    const [packDates, setPackDates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [popupVisible, setPopupVisible] = useState(true);
    const [typeSel, setTypeSel] = useState('trip');
    const [isExpanded, setIsExpanded] = useState(false);
    const packId = useRef(window.location.pathname.split('/')[4]);
    const type = window.location.pathname.split('/')[2];
    const [allowedDates, setAllowedDates] = useState([]);
    const navigate = useNavigate();
    const [interestedTrips, setInterestedTrips] = useState([]);
    const { id } = JSON.parse(localStorage.getItem('tempOrg')) || {};
    // const [userWishlist, setUserWishlist] = useState([]);
    // const [checkTrip, setCheckTrip] = useState(false);
    // const tripStatus = location.state?.tripStatus;
    // const [comment, setComment] = useState('');
    //  const location = useLocation();
    // const [isFavourite, setIsFavourite] = useState(false);
    // const [popupRating, setPopupRating] = useState(userRating);
    // const [userRating, setUserRating] = useState(0);

    useEffect(() => {
        clearBookingStorage();
        setTypeSel((prev) => prev);
        fetchTripData(type, packId.current, setLoading, setPackData, setPackDates);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (packDates.length !== 0) {
            setAllowedDates(
                packDates.map(function (obj) {
                    return moment(obj.startDate);
                })
            );
        }
    }, [packDates]);

    useEffect(() => {
        if (!type || !packId) {
            return;
        }
        const fetchIntrestedTrips = async () => {
            try {
                const result = await getInterestedTripsOrg(type, id);
                if (result?.data) {
                    const tripData = result?.data || [];
                    setInterestedTrips(tripData);
                }
            } catch (error) {
                console.error('Error fetching interested trips:', error);
            }
        };
        fetchIntrestedTrips();
    }, [type, packId, id]);

    const carouselRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    const updateScrollButton = () => {
        const el = carouselRef.current;
        if (!el) return;

        const scrollLeft = Math.round(el.scrollLeft);
        const maxScrollLeft = el.scrollWidth - el.clientWidth;

        const canScrollLeftNow = scrollLeft > 0;
        const canScrollRightNow = scrollLeft < maxScrollLeft - 1;

        setCanScrollLeft(canScrollLeftNow);
        setCanScrollRight(canScrollRightNow);
    };

    const scrollLeft = () => {
        const el = carouselRef.current;
        if (!el) return;
        const scrollAmount = el.clientWidth;
        el.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        setTimeout(updateScrollButton, 300);
    };

    const scrollRight = () => {
        const el = carouselRef.current;
        if (!el) return;
        const scrollAmount = el.clientWidth;
        el.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        setTimeout(updateScrollButton, 300);
    };

    useEffect(() => {
        const scrollEl = carouselRef.current;
        if (!scrollEl) return;

        const handleUpdate = () => updateScrollButton();

        scrollEl.addEventListener('scroll', handleUpdate);

        // Run after layout to get correct dimensions
        setTimeout(updateScrollButton, 0);

        return () => scrollEl.removeEventListener('scroll', handleUpdate);
    }, [interestedTrips]);

    const baseCities = packData?.quickView?.baseCities;
    const startCityLocation = baseCities && baseCities.split(',');

    // const closePopup = () => setPopupVisible(false);
    return (
        <div>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            {Object.keys(packData).length !== 0 ? (
                <>
                    <div className='tripDetailsHeadingDivHostOrg'>
                        <h1 className='detailsImageDisplayName'>
                            <span>{packData?.title || 'N/A'}</span>
                            <Share onClick={(e) => share(e)} />
                            <button className='shareButton' onClick={(e) => share(e)}>
                                Share
                            </button>
                        </h1>
                        <div>
                            <div className='tripBriefInfo'>
                                <span className='tripDetailsSubDetails' style={{ fontSize: 'small' }}>
                                    By
                                </span>
                                <span
                                    className='tripDetailsSubDetails'
                                    onClick={() => {
                                        navigate(`/h/orgid/${packData?.organizerId}`);
                                    }}
                                >
                                    {packData?.organizerName}
                                </span>
                                <span className='tripDetailsDot'></span>
                                <span className='tripDetailsSubDetails'>
                                    {packData?.days + 'D/' + packData?.nights + 'N'}
                                </span>
                                <span className='tripDetailsDot'></span>
                                <span className='tripDetailsSubDetails'>
                                    {packDates?.length !== 0 && getFormattedDate(packDates[0].startDate)} Onwards
                                </span>

                                <span className='tripDetailsDot'></span>
                                <span className='tripDetailsSubDetails'>
                                    From:{' '}
                                    {Array.isArray(startCityLocation) && startCityLocation.length > 3
                                        ? startCityLocation.slice(0, 3).join(',')
                                        : startCityLocation.join(',')}
                                </span>

                                {/* <span className='tripDetailsDot'></span>
                                <span className='tripDetailsSubDetails'>{packData?.quickView?.startTime}</span>
                                <span className='tripDetailsDot'></span>
                                <span className='tripDetailsSubDetails'>{packData?.quickView?.stay}</span>
                                <span className='tripDetailsDot'></span>
                                <span className='tripDetailsSubDetails'>{packData?.quickView?.food}</span>
                                <span className='tripDetailsDot'></span>
                                <span className='tripDetailsSubDetails'>{packData?.quickView?.type[0]}</span>
                                <span className='tripDetailsDot'></span>
                                <span className='tripDetailsSubDetails'>{packData?.quickView?.difficulty}</span>
                                <span className='tripDetailsDot'></span> */}
                                <span className='tripDetailsSubDetails alignCenter'>
                                    <ReviewStars rating={packData?.rating || 0} />
                                    <span>{packData?.rating || 0}</span>
                                    {/* <p style={{ margin: 0 }}>({packData?.reviewCount || 0} Reviews)</p> */}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className='tripDetailsHostOrg'>
                        <DetailsImageDisplay imageData={packData.images} videoData={packData.videos} />
                        <div className='tripDetailsTextBooking'>
                            <div className='tripDetailsText'>
                                <DetailsTabs
                                    tripDetailsData={packData}
                                    isExpanded={isExpanded}
                                    setIsExpanded={setIsExpanded}
                                    typeSel={typeSel}
                                />
                                {interestedTrips && interestedTrips.length > 0 && !isMobile && (
                                    <>
                                        <div className='carousel'>
                                            <p className='carousel-header'>You might be interested in</p>
                                        </div>
                                        <div className='carousel-container'>
                                            {canScrollLeft && (
                                                <button className='modalNavButton left' onClick={scrollLeft}>
                                                    ‹
                                                </button>
                                            )}
                                            <div className='searchResultContentAreaTrip' ref={carouselRef}>
                                                <TripCard imageData={interestedTrips} interested={true} />
                                            </div>
                                            {canScrollRight && (
                                                <button className='modalNavButton right' onClick={scrollRight}>
                                                    ›
                                                </button>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className='tripDetailsBooking'>
                                <TripBookingTab
                                    packData={packData}
                                    setPackData={setPackData}
                                    allowedDates={allowedDates}
                                    packDates={packDates}
                                    setLoading={setLoading}
                                    isExpanded={isExpanded}
                                    setIsExpanded={setIsExpanded}
                                />
                            </div>
                            {isMobile && (
                                <>
                                    <div className='carousel'>
                                        <p className='carousel-header'>You might be interested in</p>
                                    </div>
                                    <div className='carousel-container'>
                                        {canScrollLeft && (
                                            <button className='modalNavButton left' onClick={scrollLeft}>
                                                ‹
                                            </button>
                                        )}
                                        <div className='searchResultContentAreaTrip' ref={carouselRef}>
                                            <TripCard imageData={interestedTrips} interested={true} />
                                        </div>
                                        {canScrollRight && (
                                            <button className='modalNavButton right' onClick={scrollRight}>
                                                ›
                                            </button>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <EmptyPage />
            )}
        </div>
    );
}
